import React from "react";
import {Chip} from "@mui/material";
import MDBox from "../../../../materialDashboard/components/MDBox";

const FeatureSelectionChips = ({
    selectedFeatures,
    activeFeatureId,
    setActiveFeatureId,
    onDeSelectFeature,
    getLabel,
    sx = {}
}) => {
    if (!selectedFeatures || selectedFeatures.length === 0) {
        return null;
    }

    return (
        <MDBox sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, ...sx }}>
            {selectedFeatures.map((feature) => (
                <Chip
                    size="small"
                    key={feature.properties.id}
                    label={getLabel ? getLabel(feature) : (feature.properties.code || feature.properties.name || feature.properties.id)}
                    onClick={setActiveFeatureId ? () => setActiveFeatureId(feature.properties.id) : undefined}
                    color={activeFeatureId === feature.properties.id ? "info" : "default"}
                    variant={activeFeatureId === feature.properties.id ? "filled" : "outlined"}
                    onDelete={() => onDeSelectFeature(feature)}
                />
            ))}
        </MDBox>
    );
};

export default FeatureSelectionChips;
